import React, { useEffect, useState } from "react";
import Sidebar from "./sections/sidebar";
import Breadcrumb from "../dashboard/sections/breadcrumb";

import {
  fetchSingleDocument,
  postDocument,
} from "../../../states/actions/fetchSingleDocuments";
import { useSelector, useDispatch } from "react-redux";
import LoadingScreen from "../../common/LoadingScreen";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import toast, { Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import DocumentForm from "./documents/form";
export default function AddDocument() {
  const { document_id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchSingleDocuments.content);
  const isLoading = useSelector(
    (state) => state.fetchSingleDocuments.isLoading
  );
  const isFormProcessing = useSelector(
    (state) => state.fetchSingleDocuments.isFormProcessing
  );
  useEffect(() => {
    dispatch(fetchSingleDocument(document_id));
  }, []);
  const handleDocumentForm = (frmData) => {
    // ; return;
    dispatch(postDocument(frmData, document_id));
  };
  useEffect(() => {
    if (document_id > 0 && data?.document_row === null) {
      window.location.href = "/documents";
    }
  }, [document_id, data?.document_row]);

  useDocumentTitle(
    data?.document_row?.id > 0
      ? "Edit Document - Loftus"
      : "Add Document - Loftus"
  );
  if (isLoading) return <LoadingScreen />;
  const branches = data?.branches;
  const document_row = data?.document_row;
  return (
    <>
      <ToastContainer />
      <div index="" className="main_dashboard commercial_dashboard_new">
        <section className="dashboard">
          <div className="contain">
            <div className="flex dash_intro_flex">
              <div className="colL">
                <Sidebar active="documents" />
              </div>
              <div className="colR ">
                <Breadcrumb
                  page_name={document_id > 0 ? "Edit Document" : "Add Document"}
                  parent_name="Documents"
                  parent_link="/documents"
                />
                <div className="page_body">
                  <div class="dash_form_blk">
                    <DocumentForm
                      handleDocumentForm={handleDocumentForm}
                      isFormProcessing={isFormProcessing}
                      branches={branches}
                      document_row={document_row}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
